import React from 'react'
import { useDayforceWebhookDetailContextValue } from '../context/DayforceWebhookDetailProvider'
import { PayloadRenderer } from 'pages/Dayforce/shared/components/PayloadRenderer'

export const UnknownWebhook = () => {
  const {
    state: { data },
  } = useDayforceWebhookDetailContextValue()

  return <PayloadRenderer payload={data.payloadBase64} />
}
